import { SERVICE_URL } from "./ServiceURL"

class MailService {

  constructor(resource) {
    this.store = resource.$store
    this.http = resource.$http
  }

  send(mail) {
    return this.http
      .post(`${SERVICE_URL}v1/mail/call-to-app`, { mail }, {
        headers: {
          "x-access-token": this.store.state.user.token || ""
        }
      })
      .then((response) => response.json())
      .then((contact) => contact)
      .catch((err) => err.body.message || err.message)
  }
}

export default MailService



// WEBPACK FOOTER //
// ./src/service/MailService.js